import { useState, useEffect } from "react";

const useKeyPress = (targetKey, isPrevent = false, meta = false, ctrl = false, shift = false, combined = false) => {
  const [keyPressed, setKeyPressed] = useState(false);

  useEffect(() => {

    function downHandler(e) {
      const { key, metaKey, ctrlKey, shiftKey } = e;

      if (combined && key === targetKey && meta === metaKey && ctrl === ctrlKey && shift === shiftKey ) {
        setKeyPressed(true);
        if (isPrevent) {
          e.preventDefault();
        }
      } else if (!combined && key === targetKey && (meta === metaKey || ctrl === ctrlKey) && shift === shiftKey ) {
        setKeyPressed(true);

        if (metaKey === true || ctrlKey === true || shiftKey === true) { //Force Release on CTRL / META / SHIFT
          setTimeout(() => {
            setKeyPressed(false);
          }, 500)
        }

        if (isPrevent) {
          e.preventDefault();
        }
      }
    }

    const upHandler = (e) => {
      const { key } = e;
      if (key === targetKey) {
        setKeyPressed(false);
        if (isPrevent) {
          e.preventDefault();
        }
      }
    };

    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [setKeyPressed, targetKey, meta, ctrl, shift, combined, isPrevent]);

  return keyPressed;
};

export default useKeyPress;
